module.exports = __webpack_public_path__ + "static/media/practice-area.e9165247.svg";